<template>
  <tr @onmouseleave="show = false" @onmouseenter="show = true" :id="section + (field ? '-' + field : '')">
    <v-tooltip color="white" v-model="show" v-if="tooltipText" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
      <template v-slot:activator="{on, attrs}">
        <td colspan="2" v-bind="attrs" v-on="on" class="">
          <div class="d-flex flex-row justify-space-between">
            <slot></slot>
          </div>
        </td>
      </template>
      <div v-html="tooltipText"></div>
    </v-tooltip>
    <td colspan="2" v-else>
      <div class="d-flex flex-row justify-space-between" v-if="!lockedFields.includes(field)">
        <slot></slot>
      </div>
      <div v-else class="d-flex flex-row justify-space-between">
        <div>{{ label }}</div>
        <div>
          <v-icon color="red" size="20" @click="dialog = true">mdi-lock</v-icon>
          <v-dialog v-model="dialog" max-width="400">
            <v-card elevation="2" color="orange lighten-5">
              <v-card-title class="headline">{{ $t("field-locked-title") }}</v-card-title>
              <v-card-text>
                {{ $t("field-locked-message") }}
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">{{ $t("cancel") }}</v-btn>
                <v-btn color="primary" @click="upgrade">{{ $t("upgrade") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </td>
  </tr>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator"

@Component
export default class TooltipTR extends Vue {
  user: any = null

  @Prop({required: true})
  section

  @Prop()
  field

  @Prop()
  label

  show = false
  dialog = false

  lockedFields: any = []

  tooltipText = ""
  language

  restricted = false

  constructor() {
    super()
    this.user = this.$store.getters.profile
    if (this.user?.subscription?.planId == "free" || this.user?.subscription?.planId == "trial") {
      this.restricted = true
      this.restrictForLockedFields()
    }
  }

  async restrictForLockedFields() {
    this.lockedFields = (await this.$store.dispatch("subscription/getLockedFields")) || []
  }

  upgrade() {
    console.log("Upgrade to package clicked")
    // Implement actual upgrade logic or navigation here
    this.dialog = false
    //route to plans
    this.$router.push("/plans")
  }

  async mounted() {
    this.language = localStorage.getItem("user-language") || "en"

    let key = this.section
    const sectionContentJson = (await this.$store.dispatch("tooltip/getTooltipContent", key)) || {}

    if (!sectionContentJson) {
      return
    }

    if (this.field) {
      let keyDash = this.field.replaceAll("_", "-")
      let fieldContentJson = sectionContentJson?.fields[keyDash]
      if (fieldContentJson) {
        this.tooltipText = fieldContentJson?.lang?.[this.language]?.text || fieldContentJson?.text || ""
      }
    } else {
      this.tooltipText = sectionContentJson?.lang?.[this.language]?.text || sectionContentJson?.text || ""
    }
  }
}
</script>
